import Drawer from '@material-ui/core/Drawer';
import React, {useEffect, useState} from 'react';

import {NAV_AND_VIEW_BAR_OFFSET} from '../MultiRunWorkspace/constants';
import {
  INITIAL_DRAWER_WIDTH,
  INLINE_WORKSPACE_DRAWER_DURATION,
} from './constants';

export const FloatingWorkspaceDrawer = ({
  isDrawerOpen,
  closeWorkspaceDrawer,
  children,
}: {
  isDrawerOpen: boolean;
  closeWorkspaceDrawer: () => void;
  children: React.ReactNode;
}) => {
  const [marginTop, setMarginTop] = useState(0);
  useEffect(() => {
    const updateMarginTop = () => {
      const scrollY = Math.ceil(window.scrollY);
      if (scrollY < NAV_AND_VIEW_BAR_OFFSET) {
        setMarginTop(NAV_AND_VIEW_BAR_OFFSET - scrollY);
      } else {
        setMarginTop(0);
      }
    };
    updateMarginTop();
    window.addEventListener('scroll', updateMarginTop);
    window.addEventListener('resize', updateMarginTop);
    return () => {
      window.removeEventListener('scroll', updateMarginTop);
      window.removeEventListener('resize', updateMarginTop);
    };
  }, []);

  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      onClose={closeWorkspaceDrawer}
      variant="persistent" // renders drawer asChild
      transitionDuration={INLINE_WORKSPACE_DRAWER_DURATION} // for consistency, make sure this matches inline drawer duration
      PaperProps={{
        style: {
          marginTop: `${marginTop}px`,
          height: `calc(100% - ${marginTop}px)`,
          boxShadow: ' 0px 12px 24px 0px rgba(21, 24, 31, 0.16)',
          width: INITIAL_DRAWER_WIDTH,
        },
      }}>
      {children}
    </Drawer>
  );
};
